import { createFileRoute, useParams } from '@tanstack/react-router';

import { LocationDetailScreen } from '@/features/locations/components/workspace/LocationDetailScreen';

export const Route = createFileRoute(
  '/_staff/admin/workspace/organizations/$orgId/locations/$locId/',
)({
  component: WorkspaceLocationDetailRoute,
});

function WorkspaceLocationDetailRoute() {
  const { orgId, locId } = useParams({
    from: '/_staff/admin/workspace/organizations/$orgId/locations/$locId/',
  });
  return <LocationDetailScreen orgId={orgId} locId={locId} />;
}
